module.exports = __webpack_public_path__ + "static/materialfusion_video-8259759f3a781a19e99601c0df5d5b90.mp4";